<template>
  <div class="container">
    <el-form ref="form" :model="form">
      <el-form-item label="标题">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <div class="part">门店信息</div>
      <div class="flex">
        <el-form-item label="">
          <el-input
            v-for="(n, i) in form.areaData"
            :key="i"
            placeholder="请输入内容"
            v-model.number="n.value"
          >
            <template slot="prepend">{{ n.name }}</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="part">今日数据</div>
      <div class="flex">
        <el-form-item label="成人">
          <el-input v-model.number="form.ageData[0].value"></el-input>
        </el-form-item>
        <el-form-item label="青少年">
          <el-input v-model.number="form.ageData[1].value"></el-input>
        </el-form-item>
        <el-form-item label="男">
          <el-input v-model.number="form.sexData[0].value"></el-input>
        </el-form-item>
        <el-form-item label="女">
          <el-input v-model.number="form.sexData[1].value"></el-input>
        </el-form-item>
      </div>
      <div class="part">统计数据</div>
      <div class="flex">
        <el-form-item label="">
          <el-input
            v-for="(n, i) in form.topData"
            :key="i+'a'"
            placeholder="请输入内容"
            v-model.number="n.value"
          >
            <template slot="prepend">{{ n.name }}</template>
          </el-input>
        </el-form-item>
      </div>

      <div class="part">教室数据</div>
      <i
        class="el-icon-plus"
        @click="form.roomData.push({ name: '', use: 0, income: 0 })"
      ></i>
      <div class="grid-box" v-for="(n, i) in form.roomData" :key="i+'b'">
        <el-input placeholder="请输入内容" v-model="n.name"> </el-input>
        <el-radio-group v-model="n.value">
          <el-radio :label="1">空闲</el-radio>
          <el-radio :label="2">拥挤</el-radio>
          <el-radio :label="3">爆满</el-radio>
        </el-radio-group>
        <i class="el-icon-delete" @click="form.roomData.splice(i, 1)"></i>
      </div>

      <div class="part">今日课程</div>
      <i
        class="el-icon-plus"
        @click="form.courseData.push({ name: '', teacher: '', time: '' })"
      ></i>
      <div class="grid-box" v-for="(n, i) in form.courseData" :key="i+'c'">
        <el-input placeholder="请输入内容" v-model="n.name">
          <template slot="prepend">课程名</template>
        </el-input>
        <el-input placeholder="请输入内容" v-model="n.teacher">
          <template slot="prepend">老师</template>
        </el-input>
        <el-input placeholder="请输入内容" v-model="n.time">
          <template slot="prepend">时间</template>
        </el-input>
        <i class="el-icon-delete" @click="form.courseData.splice(i, 1)"></i>
      </div>

      <div class="part">教室使用情况</div>
      <i
        class="el-icon-plus"
        @click="form.useRoomData.push({ name: '', teacher: '', time: '' })"
      ></i>
      <div class="grid-box" v-for="(n, i) in form.useRoomData" :key="i+'d'">
        <el-input placeholder="请输入内容" v-model="n.name">
          <template slot="prepend">课程名</template>
        </el-input>
        <el-input placeholder="请输入内容" v-model="n.teacher">
          <template slot="prepend">老师</template>
        </el-input>
        <el-input placeholder="请输入内容" v-model="n.time">
          <template slot="prepend">时间</template>
        </el-input>
        <i class="el-icon-delete" @click="form.useRoomData.splice(i, 1)"></i>
      </div>

      <div class="part">通知</div>
      <i
        class="el-icon-plus"
        @click="form.msgData.push({ name: '', teacher: '', time: '' })"
      ></i>
      <div class="grid-box" v-for="(n, i) in form.msgData" :key="i+'e'">
        <el-input placeholder="请输入内容" v-model="n.name">
          <template slot="prepend">通知</template>
        </el-input>
        <i class="el-icon-delete" @click="form.msgData.splice(i, 1)"></i>
      </div>

      <div class="part">热门教室预约人数图表</div>
      <div>
        <div class="flex">
          <el-form-item label="热门教室预约人数,5条">
            <div class="flex">
              <el-tag
                v-for="(tag, i) in form.areaTopBarData"
                @close="closeTag('areaTopBarData', i)"
                :key="'a'+i"
                closable
              >
                {{ tag.name }}:{{ tag.value }}
              </el-tag>
            </div>
          </el-form-item>
        </div>
        <el-popover placement="right" width="400" trigger="click">
          <el-form>
            <el-form-item label="教室">
              <el-input
                v-model="name"
                placeholder="参考上方教室"
              ></el-input>
            </el-form-item>
            <el-form-item label="人数">
              <el-input v-model.number="count" placeholder="数量"></el-input>
            </el-form-item>
            <el-button @click="addBar('areaTopBarData')">确定</el-button>
          </el-form>
          <el-button type="primary" slot="reference">添加数据</el-button>
        </el-popover>
      </div>

      <el-form-item label-width="8rem" label="图片">
        <avatar-uploader @getImgUrl="(v) => (form.pic = v)" :url="pic"></avatar-uploader>
      </el-form-item>
      <div class="m-t20">
        <el-button v-if="id" type="success" @click="update">修改数据</el-button>
        <el-button v-else type="warning" @click="add">新增数据</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      time: "",
      city: "杭州市",
      count: 0,
      count2: 0,
      hour: "",
      name: "",
      pic:'',
      form: {
        name: "",
        pic: "",
        areaData: [
          { name: "区域名称", value: "海马运动中心" },
          { name: "开放时间", value: "09:00-22:00" },
          { name: "负责人", value: "海马运动" },
          { name: "联系电话", value: "188****1234" },
        ],
        ageData: [
          {
            name: "成人",
            value: 10,
          },
          {
            name: "青少年",
            value: 20,
          },
        ],
        sexData: [
          {
            name: "男",
            value: 12,
          },
          {
            name: "女",
            value: 18,
          },
        ],
        //顶部数据
        topData: [
          {
            name: "当前使用教室",
            value: 3,
          },
          {
            name: "今日预约人数",
            value: 132,
          },
          {
            name: "今日课程数量",
            value: 35,
          },
          {
            name: "已上课课程",
            value: 12,
          },
        ],
        areaTopBarData: [
          {
            name: "健身房",
            value: 10,
          },
        ],
        roomData: [
          {
            name: "健身房",
            value: 0,
          },
        ],
        msgData: [
          {
            name: "xxxx通知",
          },
        ],
        courseData: [
          {
            name: "xxx课程",
            teacher: "老师",
            time: "12:00-13:00",
          },
        ],
        useRoomData: [
          {
            name: "教室",
            teacher: "老师",
            time: "12:00-13:00",
          },
        ],
      },
    };
  },

  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getInfo();
    }
  },

  methods: {
    getInfo() {
      this.$axios({
        url: "/user/sysParam/findById",
        params: {
          id: this.$route.query.id,
        },
      }).then((res) => {
        let v = res.data.data;
        this.form = JSON.parse(v.param_value);
        this.pic = this.form.pic
        this.city = v.remark;
        this.time = v.update_time.split(" ")[0];
      });
    },
    closeTag(v, i) {
      this.form[v].splice(i, 1);
    },
    addBar(v) {
      this.form[v].push({
        value: Number(this.count),
        name: this.name,
      });
    },
    addToday(v) {
      this.form[v].push({
        hour: this.hour,
        count: Number(this.count),
        count2: Number(this.count2),
      });
    },
    update() {
      this.$axios({
        url: "/user/sysParam/update",
        method: "post",
        data: {
          id: this.id,
          param_key: "space_data_user",
          param_value: JSON.stringify(this.form),
          type: "spaceDataU",
        },
      }).then((res) => {
        this.$router.back();
      });
    },
    add() {
      this.$axios({
        url: "/user/sysParam/insert",
        method: "post",
        data: {
          param_key: "space_data_user",
          param_value: JSON.stringify(this.form),
          type: "spaceDataU",
        },
      }).then((res) => {
        this.$router.back();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
}
.part {
  font-size: 16px;
  height: 30px;
  font-weight: 600;
}
</style>